<app-title-bar rootBreadCrumbs="['i18n.core.navigation.admin']" titleText="i18n.domain.parker-administration.title"></app-title-bar>
<div class="d-lg-flex align-items-center mb-2">
  <app-client-autocomplete [(selectedClient)]="selectedClient"
    class="client-autocomplete me-2"></app-client-autocomplete>
  @if(selectedClient){
    <app-parker-filter (filterUpdated)="onFilterUpdated($event)"></app-parker-filter>
    <ejs-checkbox label="{{ 'i18n.shared.show-all' | translate }}" [(checked)]="showInactive" cssClass="checkbox-large ms-auto"></ejs-checkbox>
  }
</div>
<div class="row">
  <div class="col">
    @if(selectedClient){
      <app-search-field
        placeholderText="{{ 'i18n.domain.parker-administration.overview.placeholder-search' |  translate }}"
        (searchTextChanged)="onSearchTextChanged($event)" class="me-2"></app-search-field>
    }
  </div>
</div>
@if(selectedClient) {
<div>
  <ejs-grid #grid
            class="grid-with-toolbar grid-with-footer no-search-in-checkbox-filter"
            width="100%"
            rowHeight="38"
            [dataSource]="data"
            [allowSorting]="true"
            [allowFiltering]="true"
            [filterSettings]="filterSettings"
            [allowPaging]="true"
            [pageSettings]="pageSettings"
            [allowResizing]="true"
            [editSettings]="editSettings"
            [searchSettings]="searchOptions"
            [showColumnChooser]='true'
            [toolbar]='toolbar'
            (dataBound)="dataBound()"
            (commandClick)="commandClicked($event)"
            (actionComplete)="actionComplete($event)"
            (actionBegin)="actionBegin($event)"
            (rowDataBound)="rowDataBound($event)"
            (toolbarClick)='onToolbarCommandClick($event)'>
    <e-columns>
      <e-column type='checkbox' width='40' [showInColumnChooser]="false"></e-column>
      <e-column field="id" [visible]="false" headerText="Parker ID" [isPrimaryKey]="true" width="150"></e-column>
      <e-column field="identification" [visible]="false" headerText="{{'i18n.shared.fields.identification' | translate}}"></e-column>
      <e-column field="firstName" headerText="{{'i18n.shared.fields.firstname' | translate}}" clipMode="EllipsisWithTooltip" width="150"></e-column>
      <e-column field="lastName" headerText="{{'i18n.shared.fields.lastname' | translate}}" clipMode="EllipsisWithTooltip" width="150"></e-column>
      <e-column field="email" headerText="{{'i18n.shared.fields.email' | translate}}" clipMode="EllipsisWithTooltip" width="150"></e-column>
      <e-column field="phone" [visible]="false" headerText="{{'i18n.shared.fields.phone' | translate}}" clipMode="EllipsisWithTooltip" width="150"></e-column>
      <e-column field="mobile" [visible]="false" headerText="{{'i18n.shared.fields.mobile' | translate}}" clipMode="EllipsisWithTooltip" width="150"></e-column>
      <e-column field="title" [visible]="false" headerText="{{'i18n.domain.parker-administration.overview.fields.title' | translate}}" clipMode="EllipsisWithTooltip" width="150"></e-column>

      <e-column field="address" headerText="{{'i18n.shared.fields.address' | translate}}" clipMode="EllipsisWithTooltip" width="150"></e-column>
      <e-column field="{{zipField}}" headerText="{{'i18n.shared.fields.zip' | translate}}" clipMode="EllipsisWithTooltip" width="100"></e-column>
      <e-column field="city" headerText="{{'i18n.shared.fields.city' | translate}}" clipMode="EllipsisWithTooltip" width="150"></e-column>
      <e-column field="country" headerText="{{'i18n.shared.fields.country' | translate}}" clipMode="EllipsisWithTooltip" width="150"></e-column>
      <e-column field="privateAddress" [visible]="false" headerText="{{'i18n.shared.fields.private-address' | translate}}" clipMode="EllipsisWithTooltip" width="150"></e-column>
      <e-column field="privateZIP" [visible]="false" headerText="{{'i18n.shared.fields.private-zip' | translate}}" clipMode="EllipsisWithTooltip" width="100"></e-column>
      <e-column field="privateCity" [visible]="false" headerText="{{'i18n.shared.fields.private-city' | translate}}" clipMode="EllipsisWithTooltip" width="150"></e-column>
      <e-column field="privateCountry" [visible]="false" headerText="{{'i18n.shared.fields.private-country' | translate}}" clipMode="EllipsisWithTooltip" width="150"></e-column>

      <e-column field="company.name" headerText="{{'i18n.domain.parker-administration.overview.fields.company' | translate}}" clipMode="EllipsisWithTooltip" width="150"></e-column>
      <e-column field="workplace" headerText="{{'i18n.domain.parker-administration.overview.fields.workplace' | translate}}" clipMode="EllipsisWithTooltip" width="150"></e-column>
      <e-column field="costCenter" [visible]="false" headerText="{{'i18n.domain.parker-administration.overview.fields.cost-center' | translate}}" clipMode="EllipsisWithTooltip" width="150"></e-column>
      <e-column field="employmentPercentage" [visible]="false" headerText="{{'i18n.domain.parker-administration.overview.fields.employment-percentage' | translate}}" clipMode="EllipsisWithTooltip" width="150">
        <ng-template #template let-data>
          {{data.employmentPercentage}} %
        </ng-template>
      </e-column>
      <e-column field="billing" [visible]="false" headerText="{{'i18n.domain.parker-administration.overview.fields.billing' | translate}}" clipMode="EllipsisWithTooltip" width="120px" [filter]="hasBillingFilter">
        <ng-template #filterItemTemplate let-data>{{formatIsActive(data, 'billing')}}</ng-template>
        <ng-template #template let-data>
          <span class="e-icons" [class.icon-checkmark]="data.billing"></span>
        </ng-template>
      </e-column>
      <e-column field="billingCurrency" [visible]="false" [allowFiltering]="true" [filter]="currencyCheckBoxFilter" headerText="{{'i18n.domain.parker-administration.overview.fields.billing-currency' | translate}}" clipMode="EllipsisWithTooltip" width="150">
        <ng-template #filterItemTemplate let-data>{{formatCurrency(data) | translate}}</ng-template>
        <ng-template #template let-data>
          {{formatCurrency(data) | translate}}
        </ng-template>
      </e-column>

      <e-column field="{{subscriptionAssignmentField}}" headerText="{{'i18n.domain.parker-administration.overview.fields.subscriptions' | translate}}" clipMode="EllipsisWithTooltip" [filter]="subscriptionAssignmentFilter" [allowSorting]="false" width="200">
        <ng-template #template let-data>
          {{getSubscriptionNamesAsString(data)}}
        </ng-template>
      </e-column>
      <e-column field="tags" [allowFiltering]="false" [allowSorting]="false" [valueAccessor]="getControlPlate" headerText="{{'i18n.domain.parker-administration.overview.fields.control-plate' | translate}}" clipMode="EllipsisWithTooltip" width="150"></e-column>
      <e-column field="group" [allowFiltering]="true" [filter]="groupCheckBoxFilter" headerText="{{'i18n.domain.parker-administration.overview.fields.group' | translate}}" clipMode="EllipsisWithTooltip" width="150">
        <ng-template #filterItemTemplate let-data>{{formatGroup(data) | translate}}</ng-template>
        <ng-template #template let-data>
          {{formatGroup(data) | translate}}
        </ng-template>
      </e-column>
      <e-column field="linkedUserUserName" [allowSorting]="false" [visible]="false" headerText="{{'i18n.domain.parker-administration.overview.fields.linked-user-user-name' | translate}}" clipMode="EllipsisWithTooltip" width="150"></e-column>
      <e-column field="activeParkingPermitGuid" [allowSorting]="false" [visible]="false" headerText="{{'i18n.domain.parker-administration.overview.fields.active-parking-permit-guid' | translate}}" clipMode="EllipsisWithTooltip" width="150"></e-column>
      <e-column field="parkingPermitValidUntil" [visible]="false" type="Date" format="dd.MM.yyyy" headerText="{{'i18n.domain.parker-administration.overview.fields.parker-permit-valid-until' | translate}}" clipMode="EllipsisWithTooltip" [visible]="false"></e-column>
      <e-column field="parkingPermitValidityPeriod" [allowSorting]="false" [visible]="false" headerText="{{'i18n.domain.parker-administration.overview.fields.parking-permit-validity-period' | translate}}" clipMode="EllipsisWithTooltip" width="150">
        <ng-template #template let-data>
          {{data.parkingPermitValidityPeriod}} Min
        </ng-template>
      </e-column>
      <e-column field="creationType" [visible]="false" [allowFiltering]="true" [filter]="groupCheckBoxFilter" headerText="{{'i18n.domain.parker-administration.overview.fields.creation-type' | translate}}" clipMode="EllipsisWithTooltip" width="150">
        <ng-template #filterItemTemplate let-data>{{formatCreationType(data) | translate}}</ng-template>
        <ng-template #template let-data>
          {{formatCreationType(data) | translate}}
        </ng-template>
      </e-column>

      @if(selectedClient.custom1Name) {
        <e-column field="custom1" type="string" headerText="{{selectedClient.custom1Name}} ({{'i18n.domain.parker-administration.overview.fields.customShort' | translate}}1)"
          clipMode="EllipsisWithTooltip" [visible]="false" width="150">
        </e-column>
      }
      @if(selectedClient.custom2Name) {
        <e-column field="custom2" type="string" headerText="{{selectedClient.custom2Name}} ({{'i18n.domain.parker-administration.overview.fields.customShort' | translate}}2)"
          clipMode="EllipsisWithTooltip" [visible]="false" width="150">
        </e-column>
      }
      @if(selectedClient.custom3Name) {
        <e-column field="custom3" type="string" headerText="{{selectedClient.custom3Name}} ({{'i18n.domain.parker-administration.overview.fields.customShort' | translate}}3)"
          clipMode="EllipsisWithTooltip" [visible]="false" width="150">
        </e-column>
      }
      @if(selectedClient.custom4Name) {
        <e-column field="custom4" type="string" headerText="{{selectedClient.custom4Name}} ({{'i18n.domain.parker-administration.overview.fields.customShort' | translate}}4)"
          clipMode="EllipsisWithTooltip" [visible]="false" width="150">
        </e-column>
      }
      @if(selectedClient.custom5Name) {
        <e-column field="custom5" type="string" headerText="{{selectedClient.custom5Name}} ({{'i18n.domain.parker-administration.overview.fields.customShort' | translate}}5)"
          clipMode="EllipsisWithTooltip" [visible]="false" width="150">
        </e-column>
      }
      @if(selectedClient.custom6Name) {
        <e-column field="custom6" type="string" headerText="{{selectedClient.custom6Name}} ({{'i18n.domain.parker-administration.overview.fields.customShort' | translate}}6)"
          clipMode="EllipsisWithTooltip" [visible]="false" width="150">
        </e-column>
      }
      @if(selectedClient.custom7Name) {
        <e-column field="custom7" type="string" headerText="{{selectedClient.custom7Name}} ({{'i18n.domain.parker-administration.overview.fields.customShort' | translate}}7)"
          clipMode="EllipsisWithTooltip" [visible]="false" width="150">
        </e-column>
      }
      @if(selectedClient.custom8Name) {
        <e-column field="custom8" type="string" headerText="{{selectedClient.custom8Name}} ({{'i18n.domain.parker-administration.overview.fields.customShort' | translate}}8)"
          clipMode="EllipsisWithTooltip" [visible]="false" width="150">
        </e-column>
      }
      @if(selectedClient.custom9Name) {
        <e-column field="custom9" type="string" headerText="{{selectedClient.custom9Name}} ({{'i18n.domain.parker-administration.overview.fields.customShort' | translate}}9)"
          clipMode="EllipsisWithTooltip" [visible]="false" width="150">
        </e-column>
      }
      <e-column field="comment" type="string" headerText="{{'i18n.domain.parker-administration.overview.fields.comment' |translate}}"
        clipMode="EllipsisWithTooltip" [visible]="false">
      </e-column>
      <e-column field="entryDate" type="Date" format="dd.MM.yyyy" headerText="{{'i18n.domain.parker-administration.overview.fields.entryDate' | translate}}" clipMode="EllipsisWithTooltip" [visible]="false"></e-column>
      <e-column field="exitDate" type="Date" format="dd.MM.yyyy" headerText="{{'i18n.domain.parker-administration.overview.fields.exitDate' | translate}}" clipMode="EllipsisWithTooltip" [visible]="false"></e-column>
      <e-column field="active" [visible]="showInactive" headerText="{{'i18n.shared.fields.active' | translate}}" clipMode="EllipsisWithTooltip" width="120px" [filter]="isActiveFilter">
        <ng-template #filterItemTemplate let-data>{{formatIsActive(data, 'active')}}</ng-template>
        <ng-template #template let-data>
          <span class="e-icons" [class.icon-checkmark]="data.active"></span>
        </ng-template>
      </e-column>
      <e-column headerText="" [commands]="gridCommands" width="125px" [showInColumnChooser]="false">
      </e-column>
    </e-columns>
    <ng-template #editSettingsTemplate let-data>
      <app-edit-parker-form [parkerEditForm]="gridEditForm" [client]="selectedClient"
        [rowData]="data"></app-edit-parker-form>
    </ng-template>
  </ejs-grid>
  <app-parker-function #parkerFunctionDialog></app-parker-function>
</div>
}
